document.querySelectorAll('.card__media').forEach((card) => {
  const slider = card.querySelector('.pro-image-slider');

  if (!slider) return;

  const swiper = new Swiper(slider, {
    loop: false,
    allowTouchMove: false, // optional (prevents drag)
    pagination: {
      el: slider.querySelector('.swiper-pagination'),
      clickable: true,
    }
  });

  // 👉 Hover IN → go to next slide
  card.addEventListener('mouseenter', () => {
    if (swiper.slides.length > 1) {
      swiper.slideTo(1);
    }

    // ▶️ play video if exists
    const video = slider.querySelector('video');
    if (video) {
      video.play();
    }
  });

  // 👉 Hover OUT → go back to first slide
  card.addEventListener('mouseleave', () => {
    swiper.slideTo(0);

    // ⏸ pause video
    const video = slider.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  });
});